import { createElement, select, svgIcon } from "@utils/function";

// --------------------------------------------------
// sidebar information

export default function SliderLayer(QuickBarConfig) {
  const checkIfParnterQuickBar = HQ.Properties.appSponsorQuickbarPartnerLogo;

  const checkIfAppTurnamentQuickbarLogo =
    HQ.Properties.appTurnamentQuickbarLogo;

  let columnClose = checkIfAppTurnamentQuickbarLogo ? "col-1" : "col-auto";

  const leaderboardRoundInformation =
    typeof HQ.Properties.currentRound !== "undefined"
      ? ` - <span>${
          HQ.Properties.i18n["slider"].round
        }</span><span class="round-number">${
          +HQ.Properties.currentRound > 0 ? HQ.Properties.currentRound : ""
        }</span>`
      : "";

  const mapContainer = select("#slider-wrapper");

  QuickBarConfig.map(
    ({ icon, i18n, name, title, className, sortNumber, show }) => {
      if (sortNumber === 0 || (typeof sortNumber == "undefined" && show))
        return;

      const slider = createElement("div");
      const content = slider.cloneNode(false);
      slider.className = `${className} slider`;

      // wrapper for logo | text | logo partner | close button x
      const sliderWrapper = createElement("div");
      sliderWrapper.className = `d-flex gap-1 justify-content-between slider-wrapper-content slider-title ${className}-title`;
      slider.appendChild(sliderWrapper);

      if (checkIfAppTurnamentQuickbarLogo) {
        const quickbarTournamentPartnerIframeClass =
          HQ.Properties.mode === "iframe"
            ? "quickbar_tournament_partner quickbar_tournament_partner_iframe"
            : "quickbar_tournament_partner";

        const logoColumn = createElement("img");
        logoColumn.src = checkIfAppTurnamentQuickbarLogo;
        logoColumn.className = `d-flex align-items-center h-100 logo-slider quickbar-brand ${quickbarTournamentPartnerIframeClass}`;
        logoColumn.alt = "logo tournament partner";

        // add logo to slider
        sliderWrapper.appendChild(logoColumn);
      }

      // --------------------------------------------------
      // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/650
      // #650 Renaming - Quickbar Headlines

      const quickBarObject = JSON.parse(HQ.Properties.quickBarConfig);

      const checkIfKeyExistInObject = quickBarObject.hasOwnProperty(
        `${name}_title`
      );

      let titleReplace = checkIfKeyExistInObject
        ? quickBarObject[`${name}_title`]
        : title;

      // --------------------------------------------------

      // title slider
      const createWrapperTitle = createElement("div");
      createWrapperTitle.className = "title-slider text-center col";
      const titleElement = `<span class="slider-name">${titleReplace}</span>`;
      const titleContent =
        className === "leaderboard-content" || className === "players-content"
          ? `${titleElement}${leaderboardRoundInformation}`
          : titleElement;
      createWrapperTitle.insertAdjacentHTML("beforeend", titleContent);

      sliderWrapper.appendChild(createWrapperTitle);

      content.classList.add("slider-content");

      // parnter logo
      if (checkIfParnterQuickBar) {
        const parnterQuickbarSliderClass =
          HQ.Properties.mode === "iframe"
            ? "quickbar_partner quickbar_partner_iframe"
            : "quickbar_partner";

        const partnerInQuckbar = createElement("div");
        partnerInQuckbar.className = `parnter-quickbar-slider text-center col-3 ${parnterQuickbarSliderClass}`;

        const createImageQuickbarPartner = createElement("img");
        createImageQuickbarPartner.src = checkIfParnterQuickBar;
        createImageQuickbarPartner.classList.add("img-fluid");
        createImageQuickbarPartner.alt = "partner logo";

        let linkWrapper = checkPresentinQuickbarPartner();

        if (linkWrapper) {
          linkWrapper.appendChild(createImageQuickbarPartner);
          partnerInQuckbar.appendChild(linkWrapper);
        } else {
          partnerInQuckbar.appendChild(createImageQuickbarPartner);
        }

        sliderWrapper.appendChild(partnerInQuckbar);
      }

      // close button
      const buttonCloseWrapper = createElement("div");
      buttonCloseWrapper.className = "button-close-slider";
      const buttonClose = createElement("button");
      buttonClose.classList.add("close-slider");
      buttonClose.setAttribute("aria-label", `${title} - close button`);
      buttonClose.insertAdjacentHTML(
        "beforeend",
        svgIcon({ className: "icon", name: "icon-close" })
      );

      buttonCloseWrapper.append(buttonClose);
      sliderWrapper.appendChild(buttonCloseWrapper);

      slider.appendChild(content);

      mapContainer.insertAdjacentElement("afterbegin", slider);
    }
  );
}

function checkPresentinQuickbarPartner() {
  // HQ.Properties.appSponsorQuickbarPartnerLink
  // presenting_partner: HQ.Properties.appSponsorPresentingPartner,
  // quickbar_partner: HQ.Properties.appSponsorQuickbarPartner,

  if (
    HQ.Properties.appSponsorQuickbarPartner &&
    HQ.Properties.appSponsorQuickbarPartnerLink
  ) {
    const linkElement = createElement("a");
    linkElement.href = HQ.Properties.appSponsorQuickbarPartnerLink;
    linkElement.target = "_blank";

    return linkElement;
  }
}
